export default __webpack_public_path__ + "images/title-slide-background-with-gradient.73bb6fb30ee59910c0fa4443172fece5.png";